import React, { useContext, useMemo } from 'react'
import { LeagueContext } from 'Context'
import { HomeFeed } from 'Api/Feed/feed.types'
import { FeedCardList } from './FeedCardList'
import { VideoCategories } from './Videos/categorySlider/VideoCategories'
import { Box } from 'Components/Layout'
import { Head2 } from 'Components/Typography/Text.styles'

type FeedCardProps = {
  sectionId: keyof HomeFeed
  theme?: 'light' | 'dark'
}

export const FeedSection: React.FC<React.PropsWithChildren<FeedCardProps>> = ({
  sectionId,
  theme = 'light',
}) => {
  const { homeFeed } = useContext(LeagueContext)!

  const sectionData = useMemo(() => {
    if (!homeFeed) return null
    return homeFeed?.[sectionId] || null
  }, [homeFeed, sectionId])
  if (!sectionData) return null

  return (
    <>
      {sectionData.type === 'feed' && (
        <Box>
          {sectionData.title && <Head2>{sectionData.title}</Head2>}
          <FeedCardList
            feedItems={sectionData?.feedItems || []}
            section={sectionId}
            theme={theme}
          />
        </Box>
      )}
      {sectionData?.type === 'categories' && (
        <VideoCategories
          categories={sectionData?.categories || []}
          categorySectionTitle={sectionData.title ?? ''}
        />
      )}
    </>
  )
}
